export default {
  maxFilesize: 1000
};
